import { forwardRef, useMemo } from "react";
import { isWeb, Stack, styled } from "@tamagui/core";
import { getShadowProps } from "../../helpers/tokens.mjs";
import { createAnchorOrButtonFrame } from "../shared/anchorOrButton.mjs";
import { jsx } from "react/jsx-runtime";
const sharedConfig = {
    name: "PressableBox",
    variants: {
      shadow: shadowToken => getShadowProps(shadowToken),
      disabled: {
        true: {
          pointerEvents: "none"
        }
      }
    }
  },
  ButtonFrame = styled(Stack, {
    ...sharedConfig,
    tag: "button",
    role: "button",
    cursor: "pointer",
    userSelect: "none",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0,
    backgroundColor: "$transparent",
    borderColor: "$transparent",
    // @ts-expect-error - web-only
    type: "button"
  }),
  AnchorFrame = styled(Stack, {
    ...sharedConfig,
    tag: "a",
    accessibilityRole: "link",
    display: "flex",
    position: "relative"
  }),
  AnchorOrButtonFrame = createAnchorOrButtonFrame({
    AnchorFrame,
    ButtonFrame
  }),
  PressableBox = forwardRef(function ({
    children,
    "aria-label": ariaLabel,
    style: styleProp,
    ...rest
  }, ref) {
    const style = useMemo(() => {
      if (isWeb) {
        const result = styleProp && typeof styleProp == "object" ? styleProp : {};
        return result["-webkit-tap-highlight-color"] = "transparent", result;
      }
      return styleProp;
    }, [styleProp]);
    return /* @__PURE__ */jsx(AnchorOrButtonFrame, {
      ref,
      "aria-label": ariaLabel || void 0,
      style,
      ...rest,
      children
    });
  });
export { PressableBox };